<template>
    <b-autocomplete
        v-model="input"
        :data="filteredDataArray"
        :placeholder="placeholder"
        @select="itemSelected"
        :clear-on-select="clear"
        :open-on-focus="true"
        :field="field">
        <template slot="empty">No results found</template>
    </b-autocomplete>
</template>

<script>
export default {
  name: 'ControlButton',
  //props: ['clear', 'placeholder', 'data', 'model', 'field'],
  props: {
    clear: { type: Boolean, default: () => false },
    placeholder: { type: String, default: () => null },
    data: {type: Array, default: () => []},
    model: { type: String, default: () => null },
    field: { type: String, default: () => null },
  },
  data(){
      return{
           input: '',
      }
  },
  computed: {
        filteredDataArray() {
            let self = this
            return this.data.filter(item => {
                return item[this.field]
                    .toString()
                    .toLowerCase()
                    .indexOf(self.input.toLowerCase()) >= 0
            })
        }
    },
    watch:{
        model(data){
            this.input = data
        }
    },
    methods: {
        itemSelected(option){
            this.$emit('selected', option)
        }
    },
    created(){
        if(this.model)
            this.input = this.model
    }
}
</script>
